import { useCallback } from 'react';

export const usePagination = ({ pageNumber, setpageNumber, totalPages }) => {

    const handleNextPage = useCallback(() => {
        setpageNumber((current) => {
            const nextPage = Math.min(current + 1, totalPages - 1); 
            return nextPage;
        });
    }, [setpageNumber, totalPages]);

    const handlePrevPage = useCallback(() => {
        setpageNumber((current) => {
            const prevPage = Math.max(0, current - 1); 
            return prevPage;
        });
    }, [setpageNumber]);

    const handlePageClick = useCallback((number) => {
        setpageNumber(number);
    }, [setpageNumber]);

    const getPageNumbers = useCallback(() => {
        if (totalPages <= 0) return []; 

        const pages = [];

        if (totalPages <= 7) {
            for (let i = 0; i < totalPages; i++) {
                pages.push(i);
            }
            return pages;
        }

        pages.push(0);

        if (pageNumber > 2) {
            pages.push('...');
        }

        for (let i = Math.max(1, pageNumber - 1); i <= Math.min(totalPages - 2, pageNumber + 1); i++) {
            pages.push(i);
        }

        if (pageNumber < totalPages - 3) {
            pages.push('...');
        }
        
        pages.push(totalPages - 1);

        return pages;
    }, [pageNumber, totalPages]);

    return {
        pageNumber,
        setpageNumber,
        totalPages,
        handleNextPage,
        handlePrevPage,
        handlePageClick,
        getPageNumbers,
    };
};
